import { useEffect, useState } from 'react';

// Una scheda per servizio, pronto o tuo (30/09/2026, pagina Servizi): chiusa
// dice cos'è, in che stato è e quali automazioni lo usano; aperta mostra «Cosa
// puoi fare». Prima ogni operazione aveva tre pillole e un cestino in vista, e
// la pagina era lunga otto schermate.

// Le automazioni che usano un servizio: la parola di comando, o il nome.
export const usatoDa = (flows, usa) => flows.filter(f => (f.steps || []).some(usa)).map(f => f.prefix || `«${f.name}»`);

// «30 set 01:04»: quando è successo un errore.
export const quando = valore => new Date(valore).toLocaleString('it-IT', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

const TONI = { ok: 'text-brand-700 border-brand-500', errore: 'text-danger border-danger', neutro: 'text-muted' };

export default function SchedaServizio({ nome, frase, stato, uso = [], tuo = false, apriSubito = false, children }) {
  // Si apre da sola se c'è qualcosa da fare (un collegamento mancante), ma non
  // si richiude mai da sola mentre ci si lavora.
  const [aperta, setAperta] = useState(apriSubito);
  useEffect(() => { if (apriSubito) setAperta(true); }, [apriSubito]);
  return <details className="rounded-xl border bg-surface" open={aperta}
    onToggle={e => { if (e.currentTarget.open !== aperta) setAperta(e.currentTarget.open); }}>
    <summary className="flex min-h-[44px] cursor-pointer list-none items-start justify-between gap-3 p-4 [&::-webkit-details-marker]:hidden">
      <span className="min-w-0">
        <span className="block break-words font-medium text-ink">{nome}</span>
        {frase && <span className="block break-words text-sm text-muted">{frase}</span>}
        <span className="block text-xs text-muted">{uso.length ? `Usato da ${uso.join(', ')}` : 'Nessuna automazione lo usa'}</span>
      </span>
      <span className="flex shrink-0 flex-col items-end gap-1">
        {stato && <span className={`rounded-full border px-2 py-0.5 text-[11px] ${TONI[stato.tono] || TONI.neutro}`}>{stato.testo}</span>}
        {tuo && <span className="rounded-full border px-2 py-0.5 text-[11px] text-muted">tuo</span>}
      </span>
    </summary>
    <div className="space-y-4 border-t p-4">{children}</div>
  </details>;
}

// Il titolo di una parte della scheda: «Cosa puoi fare», «Collegamento».
export function Parte({ titolo, children }) {
  return <section className="space-y-2">
    <h4 className="text-xs font-medium uppercase tracking-wide text-muted">{titolo}</h4>
    {children}
  </section>;
}
